// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","242":"project","443":"about"}[chunkId] + "." + {"176":"15fcbe5c","242":"951b4c1f","443":"723f0902"}[chunkId] + ".js";
};